export default {
  type: "Feature",
  properties: {
    name: "Булган",
    location: [48.34276584844379, 103.30188444271364],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [101.6658067703247, 48.962750894091165],
        [101.63246154785156, 49.06351915895547],
        [101.634521484375, 49.127813961593255],
        [101.7169189453125, 49.2355341957325],
        [101.788330078125, 49.24270720875383],
        [101.8377685546875, 49.30363576187125],
        [102.00256347656249, 49.38594874941847],
        [102.1563720703125, 49.40739905889802],
        [102.29919433593749, 49.439556958940855],
        [102.40905761718749, 49.50024216453777],
        [102.48870849609375, 49.596470070892686],
        [102.5079345703125, 49.62672481765915],
        [102.53402709960938, 49.64184514921545],
        [102.57247924804686, 49.64273443429918],
        [102.64389038085938, 49.635619698841445],
        [102.67822265625, 49.64362370314076],
        [102.78482437133789, 49.69173115108819],
        [102.70843505859375, 49.742231602580716],
        [102.5628662109375, 49.786584231227586],
        [102.48596191406249, 49.80254124506291],
        [102.20718383789062, 49.8787077521734],
        [102.13302612304688, 49.90348026046574],
        [102.10281372070312, 49.92912409759547],
        [102.10418701171874, 49.96977255919705],
        [102.12753295898436, 50.004208515595614],
        [102.21817016601562, 50.07388786455134],
        [102.22091674804686, 50.08710669808234],
        [102.24838256835938, 50.11089141378986],
        [102.35687255859375, 50.18393346184497],
        [102.37884521484375, 50.217337177613686],
        [102.39532470703125, 50.2691545281742],
        [102.41455078125, 50.29986701674912],
        [102.50106811523438, 50.35772808048406],
        [102.645263671875, 50.41114309193372],
        [102.645263671875, 50.41125248716129],
        [102.67822265625, 50.396262987870436],
        [102.74414062499999, 50.40501655606602],
        [102.76336669921875, 50.38050249104245],
        [102.85675048828125, 50.34020186462779],
        [102.9034423828125, 50.331436330838834],
        [102.9254150390625, 50.30863837348728],
        [102.974853515625, 50.305130024910035],
        [103.04351806640625, 50.31214646324747],
        [103.07922363281249, 50.32091555536218],
        [103.150634765625, 50.31214646324747],
        [103.18084716796874, 50.331436330838834],
        [103.20831298828125, 50.33844888725473],
        [103.27972412109375, 50.28758439955972],
        [103.25775146484374, 50.25247373417045],
        [103.27423095703124, 50.23842221881728],
        [103.26599121093749, 50.20679116099068],
        [103.29071044921875, 50.189209286782585],
        [103.35113525390625, 50.20327530414826],
        [103.42803955078125, 50.21382209771753],
        [103.524169921875, 50.1962428134763],
        [103.53515625, 50.182174724020506],
        [103.59283447265625, 50.17162093714734],
        [103.6065673828125, 50.14698636755676],
        [103.6669921875, 50.14522626967904],
        [103.721923828125, 50.12938247393472],
        [103.76312255859375, 50.168102490105014],
        [103.798828125, 50.15754559464304],
        [103.84002685546875, 50.1962428134763],
        [103.875732421875, 50.1962428134763],
        [103.88397216796875, 50.182174724020506],
        [103.94439697265624, 50.18393346184497],
        [103.9581298828125, 50.16634316943973],
        [104.0185546875, 50.154026111358014],
        [104.1448974609375, 50.14522626967904],
        [104.2767333984375, 50.20503326494332],
        [104.2767333984375, 50.2349086926556],
        [104.30694580078125, 50.24281376239237],
        [104.34505462646484, 50.25351645493256],
        [104.36067581176758, 50.26465567878524],
        [104.36067581176758, 50.26454594544213],
        [104.45114135742186, 50.21557967003726],
        [104.52117919921874, 50.14962639292665],
        [104.54864501953125, 50.10032188683107],
        [104.55551147460938, 50.05008477838258],
        [104.61456298828124, 50.0086215988794],
        [104.60220336914062, 49.993615462541136],
        [104.58023071289062, 49.98743510374161],
        [104.51156616210938, 49.983020075472226],
        [104.51568603515625, 49.90082667133223],
        [104.53216552734375, 49.85303710579436],
        [104.58297729492188, 49.81229016526221],
        [104.688720703125, 49.73779410787209],
        [104.732666015625, 49.686289508355735],
        [104.67361450195312, 49.64451295574021],
        [104.67086791992188, 49.54481568504451],
        [104.66537475585938, 49.48775429690567],
        [104.64065551757812, 49.435984899682005],
        [104.61181640625, 49.3993562906839],
        [104.5953369140625, 49.3653834114396],
        [104.54864501953125, 49.22836014090129],
        [104.53628540039062, 49.15296965617039],
        [104.51911926269531, 49.106017014812096],
        [104.51946258544922, 49.106017014812096],
        [104.44427490234375, 49.127813961593255],
        [104.39071655273438, 49.1314084139986],
        [104.33303833007812, 49.11882669045988],
        [104.2822265625, 49.080162863460984],
        [104.10232543945312, 49.12062427498834],
        [104.05838012695312, 49.095452162534826],
        [103.99932861328124, 49.03876821195109],
        [103.99932861328124, 48.98562459864604],
        [104.1558837890625, 48.957678947281124],
        [104.24514770507812, 48.94595514118904],
        [104.30694580078125, 48.927913136732556],
        [104.34677124023438, 48.90805939965008],
        [104.37801361083984, 48.899258060699516],
        [104.37801361083984, 48.89948375541988],
        [104.47723388671875, 48.83941303819501],
        [104.54452514648436, 48.786961645533275],
        [104.51568603515625, 48.73264383158835],
        [104.51980590820312, 48.66103577846602],
        [104.52821731567383, 48.625760872755635],
        [104.52838897705078, 48.62564740882851],
        [104.53834533691406, 48.53479452317522],
        [104.534912109375, 48.42191010942875],
        [104.50332641601562, 48.355336473558054],
        [104.43603515624999, 48.32429984442754],
        [104.39895629882812, 48.29781249243716],
        [104.36325073242188, 48.25668420754852],
        [104.33303833007812, 48.194471974688206],
        [104.28634643554688, 48.143181585289554],
        [104.33990478515625, 48.10559716402152],
        [104.37835693359375, 48.058807426879575],
        [104.39346313476562, 47.98624517426206],
        [104.44976806640625, 47.96785877999253],
        [104.55001831054688, 47.94946583788702],
        [104.66537475585938, 47.94762618352869],
        [104.68597412109375, 47.954064687296885],
        [104.70932006835938, 47.933826688535746],
        [104.710693359375, 47.90989883771289],
        [104.69146728515625, 47.897930761804936],
        [104.69558715820312, 47.82883013320963],
        [104.72991943359375, 47.7263921299974],
        [104.7601318359375, 47.66168780332917],
        [104.64614868164061, 47.65521295468833],
        [104.52392578125, 47.65336285044987],
        [104.51019287109375, 47.628380027447136],
        [104.4854736328125, 47.59875528481801],
        [104.38385009765625, 47.60060732292067],
        [104.28909301757812, 47.58486290927609],
        [104.15313720703125, 47.525547335516556],
        [104.07073974609375, 47.470806305936264],
        [104.095458984375, 47.41229100755385],
        [104.13803100585938, 47.386263315961884],
        [104.17098999023436, 47.35650163792198],
        [104.16961669921875, 47.32951560950956],
        [104.14764404296874, 47.29809208596965],
        [104.14764404296874, 47.29809208596965],
        [104.04876708984375, 47.27922900257082],
        [103.93890380859375, 47.26432008025478],
        [103.86474609375, 47.25593196573788],
        [103.77685546875, 47.26338813315705],
        [103.67712020874023, 47.25068871930782],
        [103.67729187011719, 47.250805241535076],
        [103.6669921875, 47.331377157798244],
        [103.4088134765625, 47.47637579720936],
        [103.1890869140625, 47.71345768748889],
        [103.084716796875, 47.724544549099676],
        [103.0133056640625, 47.83528342275264],
        [102.843017578125, 47.90529605906089],
        [102.83752441406249, 48.02299832104887],
        [102.755126953125, 48.1367666796927],
        [102.6287841796875, 48.25394114463431],
        [102.48596191406249, 48.25759852914997],
        [102.37060546875, 48.32703913063476],
        [102.337646484375, 48.42191010942875],
        [102.2772216796875, 48.44742209577057],
        [102.2332763671875, 48.494767515307295],
        [102.2003173828125, 48.6746400785837],
        [102.12890625, 48.81048112472012],
        [102.03826904296875, 48.77248263837077],
        [101.9586181640625, 48.77429274267509],
        [101.93389892578125, 48.832181625698475],
        [101.876220703125, 48.86290791986464],
        [101.81304931640625, 48.866521538507754],
        [101.74713134765625, 48.89000369970676],
        [101.66559219360352, 48.963089005540155],
        [101.6658067703247, 48.962750894091165],
      ],
    ],
  },
};
